import { Role } from '../../pages/admin/icontact/setting/expert/agent/agent.const';

export const NavAgentList = [
  { id: '/report', title: 'Báo cáo', icon: 'fa fa-bar-chart' },
  { id: '/search/ticket', title: 'Ticket', icon: 'fa fa-search fa-ticket' },
  { id: '/chatting/all', title: 'Chat Web', icon: 'fa fa-comment' },
  { id: '/customer', title: 'Khách hàng', icon: 'fa-solid fa-address-book' },
];
export const NavTeamLead = [{ id: '/monitors', title: 'Giám sát', icon: 'fa fa-user-secret fa-lg' }];
export const NavQC = [{ id: '/smart-qc', title: 'Smart QC', icon: 'fa fa-search-plus fa-lg' }];

export const NavSuperList = [{ id: '/campaign', title: 'Chiến dịch', icon: 'fa-solid fa-paper-plane' }];
export const NavAdminList = [{ id: '/settings', title: 'Cấu hình', icon: 'fa-solid fa-gear' }];
export const getNavList = user => {
  let navList = NavAgentList;
  const accepted = ['66bc0f7bbb442d077700d499', '664c6ab59da2233c389a7676', '646ae9cffe32b43426f45165'];
  switch (user.role) {
    case Role.TeamLeader:
      navList = [
        { id: '/report', title: 'Báo cáo', icon: 'fa fa-bar-chart' },
        { id: '/search/ticket', title: 'Ticket', icon: 'fa fa-search fa-ticket' },
        { id: '/customer', title: 'Khách hàng', icon: 'fa-solid fa-address-book' },
      ];
      break;
    case Role.Supervisor:
      navList = [...navList, ...NavTeamLead];
      if (accepted.includes(user.tenant_id)) {
        navList = [...navList, ...NavQC];
      }
      navList = [...navList, ...NavSuperList];
      break;
    case Role.Administrator:
      navList = [...navList, ...NavTeamLead];
      if (accepted.includes(user.tenant_id)) {
        navList = [...navList, ...NavQC];
      }
      navList = [...navList, ...NavSuperList, ...NavAdminList];
      break;
    default:
      navList = NavAgentList;
  }
  return navList;
};

export const getCurrentTab = (url, user) => {
  const tabs = getNavList(user);
  let tab = '';
  for (const t of tabs) {
    if (url.includes(t.id)) {
      tab = t.id;
      break;
    }
  }
  return tab;
};



// WEBPACK FOOTER //
// ./src/app/layout/navigation/admin-nav.const.ts